/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vertragerhalten1Inputs */

const de__field_vertragerhalten1 = /** @type {(inputs: _Field_Vertragerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertrag erhalten`)
};

/**

* @param {_Field_Vertragerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vertragerhalten1 = /** @type {((inputs?: _Field_Vertragerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vertragerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vertragerhalten1(inputs)
});
export { _field_vertragerhalten1 as "_field_vertragErhalten" }